import type {
  AssortmentDetailDto,
  AssortmentSummaryDto,
  UpdateAssortmentRequest,
} from '@/types/Assortment'
import type { AssortmentSyncDto } from '@/types/AssortmentSync'
import { apiGet, apiGetOrNull, apiPost, apiPut, type WithEtag } from './ApiClient'

const assortmentsPath = '/assortments'
const assortmentsSyncPath = '/assortments/sync'

export async function getAssortments(): Promise<AssortmentSummaryDto[]> {
  return await apiGet<AssortmentSummaryDto[]>(assortmentsPath)
}

export async function getAssortment(id: string): Promise<WithEtag<AssortmentDetailDto>> {
  return apiGet<AssortmentDetailDto>(`${assortmentsPath}/${encodeURIComponent(id)}`) as Promise<
    WithEtag<AssortmentDetailDto>
  >
}

export async function updateAssortment(
  id: string,
  body: UpdateAssortmentRequest,
  etag: string,
): Promise<WithEtag<AssortmentDetailDto>> {
  return apiPut<AssortmentDetailDto>(`${assortmentsPath}/${encodeURIComponent(id)}`, body, {
    etag,
  }) as Promise<WithEtag<AssortmentDetailDto>>
}

export async function triggerAssortmentSync(): Promise<AssortmentSyncDto> {
  return apiPost<AssortmentSyncDto>(assortmentsSyncPath)
}

export async function getAssortmentStatus(): Promise<AssortmentSyncDto | null> {
  return apiGetOrNull<AssortmentSyncDto>(assortmentsSyncPath)
}
